// extracted by mini-css-extract-plugin
module.exports = {"container":"quick-add-tool_container__AxAjW","small":"quick-add-tool_small__5y19S","button":"quick-add-tool_button__xg6wq","selected":"quick-add-tool_selected__ZTWsb"};